<template>
  <div>
    <div class="contentBox">
      <div class="title">
        {{$t('page.certificate.title')}}
      </div>
    </div>
    <div style="margin-top: 10px">
      <el-table :data="tabledata" border style="width: 100%" tooltip-effect="dark">
        <el-table-column prop="RGID" align="center" label="RGID" ></el-table-column>
        <el-table-column prop="AttestationCode" align="center" show-overflow-tooltip
                         :label="$t('page.certificate.certificateCode')"></el-table-column>
        <el-table-column prop="Name" align="center"
                         :label="$t('page.certificate.name')" :render-header="foo"></el-table-column>
        <el-table-column prop="AuthenticationName" align="center" show-overflow-tooltip
                         :label="$t('page.certificate.authenticationName')" :render-header="foo"></el-table-column>
        <el-table-column prop="expireDate" align="center" :label="$t('page.certificate.expireDate')">
          <template slot-scope="scope" v-if="scope.row.expireDate && scope.row.expireDate.trim()!==''">
            {{scope.row.expireDate.substring(0,10)}}
          </template>
        </el-table-column>
        <el-table-column prop="workPost" align="center"
                         :label="$t('page.certificate.workPost')"></el-table-column>
        <el-table-column prop="url" align="center" :label="$t('page.certificate.certificatePreview')" :render-header="foo">
          <template slot-scope="scope">
            <el-button @click="showCertificate(scope.row)" type="text">{{$t("message.lookat")}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import API from "../../api";

  export default {
    name: "list",
    data() {
      return {
        tabledata: [],
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        API.getCertificate()
          .then(resp => {
            let json = resp.data;
            if (json.status === '200') {
              this.tabledata = json.data;
            }
          }).catch(e => {
          console.error(`error`, e)
        })
      },
      showCertificate(row){
        window.open(row.url)
      },
      foo(h,{column}){
        if(column.label){
          return(h("el-tooltip", {
            attrs: {
              class: "item",
              effect: "dark",
              content: column.label,
              placement: "bottom"
            }
          },[h("span", [column.label]),]))
        }
      }
     }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/certificate/list.vue